<template lang="pug">
v-card(flat tile)
    v-snackbar(v-model="showDownloadFailedSnackBar" :timeout="3000" color="error" )
        span {{ $t('paymentPage.errorMessage') }}
            v-btn(fab text @click="showSnackBar = false")
                v-icon fal fa-times-circle

    v-card-text.px-0.pb-0
        template(v-if="invoice")
            v-row.ma-0
                v-col.px-0(cols="4") {{ $t('paymentPage.invoiceName') }}:
                v-col.px-0.text-end(cols="8") {{ invoice.formattedPeriodRange }}

            v-divider

            v-row.ma-0
                v-col.px-0(cols="4") {{ $t('paymentPage.priceForFood') }}:
                v-col.px-0.text-end(cols="8") {{ invoice.formattedPriceItemSum }} &euro;

            v-divider

            template(v-if="invoice.amountFromDept > 0")
                v-row.ma-0.red--text
                    v-col.px-0(cols="4") {{ $t('paymentPage.unpaidPayment') }}:
                    v-col.px-0.text-end(cols="8") {{ invoice.formattedAmountFromDept }} &euro;
                v-divider

            template(v-if="invoice.amountFromWallet > 0")
                v-row.ma-0.green--text
                    v-col.px-0(cols="4") {{ $t('paymentPage.paidFromCredit') }}:
                    v-col.px-0.text-end(cols="8") {{ invoice.formattedAmountFromWallet }} &euro;
                v-divider

            v-row.ma-0.text-h6.font-weight-bold
                v-col.px-0(cols="4") {{ $t('paymentPage.toPaid') }}:
                v-col.px-0.text-end(cols="8") {{ invoice.formattedPriceTotal }} &euro;

            v-container.pa-0(v-if="invoice.priceTotal > 0" fluid)
                v-row
                    v-col(cols="12")
                        v-list(outlined)
                            v-list-item
                                v-list-item-content
                                    v-list-item-subtitle {{ $t('paymentPage.ibanLabel') }}
                                    v-list-item-title.pt-1.font-weight-bold.text-h6.text-wrap {{invoice.formattedIban}}
                            v-list-item
                                v-list-item-content
                                    v-list-item-subtitle {{ $t('paymentPage.variableSymbol') }}
                                    v-list-item-title.pt-1.font-weight-bold.text-h6.text-wrap {{invoice.formattedBoarderBankIdentificationCode}}
                            v-list-item
                                v-list-item-content
                                    v-list-item-subtitle {{ $t('paymentPage.specificSymbol') }}
                                    v-list-item-title.pt-1.font-weight-bold.text-h6.text-wrap {{invoice.specificSymbol}}
                            v-list-item
                                v-list-item-content
                                    v-list-item-subtitle {{ $t('paymentPage.constantSymbol') }}
                                    v-list-item-title.pt-1.text-wrap {{invoice.constantSymbol}}

            v-row
                v-card(flat)
                    v-card-text.text-center(v-html="$t('paymentPage.warningMessage')")

            v-row
                v-col(cols="12")
                    v-card(flat)
                        v-card-text.pa-0.text-center {{ $t('paymentPage.infoMessage') }}
                        v-card-actions.justify-center
                            v-btn(text color="primary" small :loading="downloadInProgress" @click.prevent="onDownloadInvoiceButtonClick")
                                v-icon fal fa-file-pdf
                                span.ml-2 {{ $t('paymentPage.downloadInvoice') }}


            // QR kod zablokovany dokial sa nevyriesia problemy s generovanim PBS kodu na BE
            // v-col.pt-3.justify-center(cols="12" sm="12" md="6" lg="4")
                PayBySquare(:paymentCode="invoiceData.payBySquareCode").box

        v-skeleton-loader(v-else type="list-item-three-line@7")

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {DOWNLOAD_INVOICE} from '@/store/action-types'
import {Invoice} from '@/model/Invoice'

@Component({
  components: {
    // PayBySquare
  }
})
export default class InvoiceDetailTab extends Vue {
  @Prop({type: Object}) invoice!: Invoice

  @Action(DOWNLOAD_INVOICE) downloadInvoice!: ({ (invoice: Invoice): Promise<void> })

  private downloadInProgress: boolean = false
  private showDownloadFailedSnackBar: boolean = false

  async onDownloadInvoiceButtonClick(): Promise<void> {
    if (this.invoice) {
      this.downloadInProgress = true

      try {
        await this.downloadInvoice(this.invoice)
      } catch (e) {
        this.showDownloadFailedSnackBar = true
      } finally {
        this.downloadInProgress = false
      }
    }
  }
}

</script>

<style lang="stylus" scoped>

</style>
